var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-preview"},[_c('div',{staticClass:"preview-loading-state-container"},[_c('pendo-loading-indicator',{attrs:{"loading":!_vm.isGuidePreviewVisible,"size":"large"}})],1),_c('div',{ref:"preview",staticClass:"preview",class:{
            'is-mobile-preview': _vm.isMobile,
            'is-resource-center-preview': _vm.isResourceCenterPreview
        },domProps:{"innerHTML":_vm._s(_vm.previewHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }